import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import * as platforms from '../services/platforms';
import { ToastService } from "../components/toast/toast.service";

@Injectable({ providedIn: 'root' })
export class ExternalAppService {
  private platform: any;
  private queryParamsState: any;
  private queryParamsCode: any;
  private queryParamsMerchantAlias: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService
  ) {
    this.setPlatform();
    this.getQueryParams();
  }

  private setPlatform(): void {
    const referrer = document.referrer;
    if (referrer) {
      const platform = Object.values(platforms).find(platform => referrer.includes(platform.uri));
      if (platform) {
        this.platform = platform;
        sessionStorage.setItem('app_platform_id', platform.id);
      } else if (sessionStorage.getItem('app_platform_id')) {
        this.platform = Object.values(platforms).find(platform => platform.id === sessionStorage.getItem('app_platform_id'));
      }
    }
  }

  private getQueryParams(): any {
    const queryParams = new URLSearchParams(window.location.search);
    this.queryParamsState = queryParams.get('state');
    this.queryParamsCode = queryParams.get('code');
    this.queryParamsMerchantAlias = queryParams.get('merchant');
  }

  private navigateToIntegration(integration_id: string): void {
    sessionStorage.removeItem('app_platform_id')
    this.router.navigate(['/lists'], { queryParams: { integration_id } });
  }

  private redirectToUrl(url: string): void {
    sessionStorage.removeItem('app_platform_id')
    window.location.href = url;
  }

  check(): void {
    if (!this.platform) {
      return;
    }

    if (this.queryParamsState && this.queryParamsCode && this.queryParamsMerchantAlias) {
      this.install({
        state: this.queryParamsState,
        code: this.queryParamsCode,
        merchant: this.queryParamsMerchantAlias
      });
      return;
    }

    this.http.get(`${environment.apiUrl}/external-app/check/${this.platform.id}`).subscribe((checkData: any) => {
        if (checkData.integration_id) {
          this.navigateToIntegration(checkData.integration_id);
          return;
        }

        if (checkData.redirect_url) {
          this.redirectToUrl(checkData.redirect_url);
          return;
        }
      });
  }

  install(data: any): void {
    if (!this.platform) {
      return;
    }

    const queryParams = new URLSearchParams(data);

    this.toastService.success('Estamos configurando a integração,<br>você será redirecionado em breve...', 5000);

    this.http.get(`${environment.apiUrl}/external-app/install/${this.platform.id}?${queryParams.toString()}`).subscribe((installData: any) => {
      if (installData.integration_id) {
        this.navigateToIntegration(installData.integration_id);
        return;
      }
    });
  }
}